import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "header-search" }
const _hoisted_5 = { class: "table-top" }
const _hoisted_6 = { class: "table" }
const _hoisted_7 = { class: "drawer-contain" }
const _hoisted_8 = { class: "drawer-header" }
const _hoisted_9 = { class: "drawer-header-rt" }
const _hoisted_10 = { class: "drawer-rt-btns" }
const _hoisted_11 = { class: "table" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_DialogAddCompany = _resolveComponent("DialogAddCompany")!
  const _component_insureAxDispatchDrawer = _resolveComponent("insureAxDispatchDrawer")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Back = _resolveComponent("Back")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_form, {
            inline: true,
            model: _ctx.formSearch,
            class: "demo-form-inline"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "派遣单位名称" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formSearch.serveCompanyName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formSearch.serveCompanyName) = $event)),
                    placeholder: "请输入派遣单位名称",
                    clearable: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _ctx.onSearch
                  }, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("搜索")
                    ])),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode("重置")
                    ])),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.onCompanyAdd
          }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("添加")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%","min-height":"550px"},
          "header-cell-style": { background: '#FBFBFD' },
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "可用工种" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (_ctx.onClickWork(scope.row))
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("点击查看")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "serveCompanyName",
              label: "派遣单位"
            }),
            _createVNode(_component_el_table_column, { label: "当前在保" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (_ctx.onClickNum(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.insureNum), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "status",
              label: "最新状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.formatter(scope.row.lastApplyOccupationStatus,_ctx.lastApplyOccupationStatusList,{
    valueKey: 'value'
  })), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "lastApplyOccupationName",
              label: "审核工种"
            }),
            _createVNode(_component_el_table_column, {
              prop: "lastApplyOccupationRejectRemark",
              label: "驳回理由"
            }),
            _createVNode(_component_el_table_column, {
              prop: "createTime",
              label: "建档时间"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.peopleInsureSizeChange,
          onCurrentChange: _ctx.initTableList
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_DialogAddCompany, {
      show: _ctx.showAddCompany,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showAddCompany) = $event)),
      "cur-company-id": _ctx.curCompanyId,
      id: _ctx.curId,
      "add-type": _ctx.addType,
      "insure-type": 8,
      onSuccess: _ctx.initTableList
    }, null, 8, ["show", "cur-company-id", "id", "add-type", "onSuccess"]),
    _createVNode(_component_insureAxDispatchDrawer, {
      show: _ctx.showWorkerLevel,
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showWorkerLevel) = $event)),
      id: _ctx.companyDetail.id,
      onSuccess: _ctx.initTableList
    }, null, 8, ["show", "id", "onSuccess"]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showPeopleInsure,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showPeopleInsure) = $event)),
      size: "70%",
      "with-header": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "drawer-header-lt" }, [
              _createElementVNode("div", { class: "drawer-lt-title" }, " 在保人数 ")
            ], -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_dropdown, { trigger: "click" }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "text",
                              onClick: _ctx.onDetailExport
                            }, {
                              default: _withCtx(() => _cache[13] || (_cache[13] = [
                                _createTextVNode("导出")
                              ])),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { size: "small" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_More)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  size: "small",
                  onClick: _ctx.goBack
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Back)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              inline: true,
              model: _ctx.peopleFormSearch,
              class: "demo-form-inline"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.peopleFormSearch.searchUserInfo,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.peopleFormSearch.searchUserInfo) = $event)),
                      placeholder: "请输入出险姓名或身份证",
                      clearable: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.onPeopleInsureSearch
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("搜索")
                      ])),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_el_button, { onClick: _ctx.onPeopleInsureReset }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("重置")
                      ])),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_table, {
              data: _ctx.peopleInsureList,
              style: {"width":"100%","min-height":"750px"},
              border: "",
              "header-cell-style": { background: '#FBFBFD' },
              "header-row-style": { color: '#202536' },
              "row-style": { color: '#5E617D' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "userName",
                  label: "员工姓名"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "idCardNo",
                  label: "身份证号"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "",
                  label: "在保时间"
                }, {
                  default: _withCtx((scope) => [
                    _createElementVNode("span", null, _toDisplayString(scope.row.insureStartTime) + " - " + _toDisplayString(_ctx.checkInsureEndTime(scope.row.insureEndTime)), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_table_column, {
                  prop: "serveCompanyName",
                  label: "派遣单位"
                }),
                _createVNode(_component_el_table_column, {
                  prop: "occupationName",
                  label: "工种"
                })
              ]),
              _: 1
            }, 8, ["data"]),
            _createVNode(_component_el_pagination, {
              class: "pagination",
              currentPage: _ctx.staffRecordPage,
              "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.staffRecordPage) = $event)),
              "page-size": _ctx.staffRecordSize,
              "onUpdate:pageSize": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.staffRecordSize) = $event)),
              "page-sizes": [10, 30, 50, 100],
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.staffRecordTotal,
              onSizeChange: _ctx.handleStaffRecordSizeChange,
              onCurrentChange: _ctx.initPeopleInsureList
            }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}